'use client';

import React from 'react';
import styled from 'styled-components';

import { Container } from '@/components/Container';
import Section from '@/components/Section/Section';
import { HeadingBlog } from '@/features/Blog/components/HeadingBlog';
import { PaginationBlock } from '@/features/Blog/components/PaginationBlock';
import { SmallCard } from '@/features/Blog/components/SmallCard';
import { devices } from '@/styles/breakpoints';

export const BlogsPage = ({ data }) => {
  return (
    <Container>
      <Section
        titleAs="h1"
        title="Blog"
        description="Discover strategies and stories that will inspire your next business breakthrough. Visit the Orcatec blog today and start transforming your operational excellence into tangible results."
      >
        <HeadingBlog data={data} />
        <ContentWrapper>
          {data?.data?.map((item) => (
            <Card key={item.id}>
              <SmallCard type="blog" item={item} />
            </Card>
          ))}
        </ContentWrapper>
        {!!data?.data?.length && <PaginationBlock data={data} />}
      </Section>
    </Container>
  );
};

const ContentWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  @media only screen and ${devices.desktop} {
    gap: 48px;
  }
`;

const Card = styled.div`
  max-width: 540px;
  width: 100%;
`;
